import {
    asyncActionCreator,
    // asyncPagedActionCreator,
    // valueHolderActionCreator,
} from './../../shared/redux/actions/common'
import { CHANGE_CHARGER_CONFIGURATION, FETCH_CHARGER_CONFIGURATION } from '../const'
import { getJson, sendJson } from '../../shared/utils/api'
import { ConfigItem } from '../../shared/types/charger'

export const fetchConfigurationChargers = (externalId: string) => {
    return asyncActionCreator(FETCH_CHARGER_CONFIGURATION, () =>
        getJson(`DiagnosticsAdmin/Configuration?externalId=${externalId}`)
    )
}

export const changeConfigurationChargers = (chargerId: string, configArr: ConfigItem[]) => {
    return asyncActionCreator(CHANGE_CHARGER_CONFIGURATION, () =>
        sendJson(`charger/changeConfiguration/${chargerId}`, 'POST', configArr)
    )
}
